import { NgIf } from "@angular/common";
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { CardWrapperComponent } from "../../../form/components/card-wrapper/card-wrapper.component";
import { AssistSection, NoAccessComponent } from "../../no-access/no-access.component";

@Component({
  selector: "app-page",
  templateUrl: "./page.component.html",
  styleUrls: ["./page.component.scss"],
  standalone: true,
  imports: [NgIf, NoAccessComponent, CardWrapperComponent],
})
export class PageComponent implements OnInit, AfterViewInit, AfterViewChecked {
  @Input() isLoading: boolean = false; // indien true, wordt de loading animatie met tekst getoond.
  @Input() isLoadingTitle: string = "Bezig met laden..."; // tekst die wordt getoond naast de loading animatie

  @Input() rubriek!: AssistSection;
  @Input() noAccessWebinarUrl?: string;
  @Input() hasAccess: boolean = true;

  protected showRightNav = true;

  @ViewChild("rightNavBlock") rightNavBlock: any;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngOnInit(): void {}

  ngAfterViewInit() {}

  ngAfterViewChecked(): void {
    this.showRightNav =
      this.rightNavBlock?.nativeElement && this.rightNavBlock?.nativeElement.children.length > 0;
    this.cdRef.detectChanges();
  }
}
